<template>
  <div class="login">
    <div class="mask-wrapper">
      <div class="container">
        <div class="content">
          <div class="title">登录</div>
          <el-form
            :model="form"
            :rules="rules"
            status-icon
            ref="form"
            class="login-form"
          >
            <el-form-item prop="username">
              <el-input
                type="text"
                placeholder="用户名"
                v-model="form.username"
                :maxlength="36"
                autocomplete="off"
              ></el-input>
            </el-form-item>
            <el-form-item prop="password">
              <el-input
                type="text"
                placeholder="请输入密码"
                v-model="form.password"
                :maxlength="36"
                autocomplete="off"
                @keyup.enter.native="submitForm('form')"
              ></el-input>
            </el-form-item>
            <el-form-item style="margin-top: 50px;">
              <el-button
                class="login-btn"
                type="primary"
                :loading="loading"
                @click="submitForm('form')"
              >登录</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { validPwd } from '@/utils/validate';

export default {
  name: 'Login',
  data() {
    const validPassword = (rule, value, callback) => {
      if (!value) {
        callback(new Error('密码不能为空'));
      } else if (validPwd(value)) {
        callback();
      }
      callback(new Error('您输入的密码格式错误！'));
    };
    return {
      loading: false,
      form: {
        username: '',
        password: '',
      },
      rules: {
        username: [
          { required: true, message: '用户名不能为空', trigger: 'blur' },
        ],
        password: [{ validator: validPassword, trigger: 'blur' }],
      },
    };
  },
  methods: {
    ...mapActions({
      login: 'user/login',
    }),
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.loading = true;
          this.login(this.form)
            .then(() => {
              this.loading = false;
              this.$message.success('您已成功登录！');
              this.$router.push({ name: 'index' });
            })
            .catch((err) => {
              this.loading = false;
              this.requestFailed(err);
            });
        }
        return false;
      });
    },
    requestFailed(err) {
      this.$notify.error({
        title: '错误',
        message:
          (typeof err === 'string' && err)
          || ((err.response || {}).data || {}).message
          || '请求出现错误，请稍后再试',
      });
    },
  },
};
</script>

<style lang="stylus" scoped>
@import '~assets/css/mixins'
@import '~assets/css/variables'
.login
  width 100%
  height 100%
  flex-row-nowrap()
  background-image url('../../assets/images/bg.jpg')
  background-cover()
  .mask-wrapper
    width 100%
    height 100%
    flex-row-nowrap()
    .container
      flex-row-nowrap()
      width 410px
      height auto
      border-radius 4px
      background #ffffff
      box-shadow 0px 3px 20px rgba(0, 0, 0, 0.4)
      margin 0 auto
      overflow hidden
      .content
        width 100%
        height 100%
        padding 50px 40px
        flex-column()
        align-items stretch
        justify-content center
        .title
          font-size 18px
          text-align center
          color #333333
          font-weight bold
          margin-bottom 40px
        .login-btn
          width 100%
          height 50px
        .login-form
          >>>.el-form-item
            margin-right 0
            margin-bottom 20px
            &:last-child
              margin-bottom 0
            .el-input
              width 100%
              height 50px
              line-height 50px
              .el-input__inner, .el-input__suffix
                height 50px
                line-height 50px
              .el-input__icon
                line-height 50px
          >>>.el-form-item__content
            margin-left 0 !important
          .code-btn
            width 140px
            height 50px
            box-shadow none
          .to-register
            color $theme
</style>
